import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ResponseStatoInserimento } from '../interfaces/response-stato-inserimento';
import { ApiService } from './api.service';
import { SecondHandData } from '../interfaces/second-hand';

@Injectable({
  providedIn: 'root',
})
export class ClientAcceptanceService {
    public codeBox: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private _barcode: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private _codiceBusta: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private _flagEtichetta: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private _dataMatrix: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
    private _codiceOrigine: string | null = null;
    private _isCodicePacco: boolean = false;
    private _isGuidaFlashForm: boolean = false;

    constructor(private api: ApiService,) {}

    get isGuidaFlashForm(): boolean {
      return this._isGuidaFlashForm;
    }

    set isGuidaFlashForm(value: boolean) {
      this._isGuidaFlashForm = value;
    }


    get barcode(): string {
      return this._barcode.getValue();
    }

    set barcode(value: string) {
      this._barcode.next(value);
    }

    get codiceOrigine(): string | null{
      return this._codiceOrigine;
    }

    set codiceOrigine(value: string | null) {
      this._codiceOrigine = value;
    }

    get codiceBusta(): string {
      return this._codiceBusta.getValue();
    }

    set codiceBusta(value: string) {
      this._codiceBusta.next(value);
    }

    get dataMatrix(): string[] {
      return this._dataMatrix.getValue();
    }

    set dataMatrix(value: string[]) {
      this._dataMatrix.next(value);
    }

    get flagEtichetta(): number {
      return this._flagEtichetta.getValue();
    }

    set flagEtichetta(value: number) {
      this._flagEtichetta.next(value);
    }


    get isSecondStep(): boolean{
      return this._isCodicePacco;
    }
    set isSecondStep(isSecondStep: boolean){
      this._isCodicePacco = isSecondStep;
    }

    getStatoInserimento(): Observable<ResponseStatoInserimento> {
        return this.api.retrieveIsAbleToDigitCode();
    }
}
